// 企业认证相关接口
import request from '@/utils/request'
import { tansParams } from '@/utils'

// 查询所有注册企业信息
export const companyInfoAllList = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_APPSERVER + '/api/iCompanyInfo/listCompanyInfo',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 分页查询所有注册企业信息
export const companyInfoPageList = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_APPSERVER + '/api/itemBusinessLicense/pageBusinessLicense',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 获取用户最近一次企业认证记录
export const getUserLastAuthRecord = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_APPSERVER + '/api/companyApplyAuth/getUserLastRecord',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 分页查询用企业认证记录
export const companyAuthPageList = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_APPSERVER + '/api/companyApplyAuth/pageTab',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 根据id查询用企业认证记录
export const detailCompanyAuthById = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_APPSERVER + '/api/companyApplyAuth/getById',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 添加用户企业认证记录
export const saveCompanyAuth = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_APPSERVER + '/api/companyApplyAuth/save',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 修改用户企业认证记录状态
export const updateCompanyAuthStatus = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_APPSERVER + '/api/companyApplyAuth/updateStatus',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 上传认证文件
export function uploadAuthFile() {
	return process.env.VUE_APP_BASE_API + process.env.VUE_APP_PREFIX_API_APPSERVER + '/api/companyApplyAuth/uploadAuthFile'
}

// 下载认证文件
export function downloadAuthFile(params) {
	return (
		process.env.VUE_APP_BASE_API +
		process.env.VUE_APP_PREFIX_API_APPSERVER +
		'/api/companyApplyAuth/downloadAuthFile?' +
		tansParams(params)
	)
}

// 预览认证文件
export function previewAuthFile(params) {
	return (
		process.env.VUE_APP_BASE_API +
		process.env.VUE_APP_PREFIX_API_APPSERVER +
		'/api/companyApplyAuth/previewAuthFile?' +
		tansParams(params)
	)
}

// 移交管理员
export const handOverAdmin = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_APPSERVER + '/api/iUserInfo/handOverAdmin',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}
